import React from "react";
import OwButton from "../../shared/OwButton/OwButton";
import OwTitle from "@components/shared/OwTitle/OwTitle";
import OwLabel from "../../shared/OwLabel/OwLabel";

type Props = {
    itemCount: number;
    closeModalFn: () => void;
    confirmFn: () => void;
};

export const CancelInactiveCartModal: React.FC<Props> = (props) => {
    return (
        <div className={"CancelInactiveCartModal p-4"}>
            <div className={"w-100 d-flex"}>
                <div className={"w-100 text-end"}>
                    <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={props.closeModalFn} />
                </div>
            </div>
            <div className={"mt-4 text-center"}>
                <OwTitle leftIconName={"fad fa-exclamation-triangle"} title={"pending_cart_detail_cancel_confirm_title"} tag={"h3"} />
            </div>
            <div className={"mt-4 text-center"}>
                <OwLabel title={"pending_cart_detail_cancel_confirm_body"} />
                <div className={"mt-2"}>
                    <strong>{props.itemCount}</strong> <OwLabel title={props.itemCount === 1 ? "item" : "items"} />
                </div>
            </div>
            <div className={"mt-5 d-flex justify-content-center gap-3"}>
                <OwButton title={"pending_cart_detail_cancel_confirm_no"} fn={props.closeModalFn} />
                <OwButton title={"pending_cart_detail_cancel_confirm_yes"} fn={props.confirmFn} className={"btn-danger"} />
            </div>
        </div>
    );
};
